import React, { useMemo } from "react";
import { Box, Stack, Typography } from "@mui/material";

export default function TrafficSourcesChart({ sources = [] }) {
    const rows = useMemo(() => {
        const list = Array.isArray(sources) ? sources : [];
        const max = Math.max(1, ...list.map((r) => Number(r.sessions) || 0));
        return list.map((r) => ({
            ...r,
            pct: ((Number(r.sessions) || 0) / max) * 100,
        }));
    }, [sources]);

    if (!rows.length) {
        return (
            <Typography variant="body2" color="text.secondary" sx={{ py: 4, textAlign: "center" }}>
                No traffic source data yet.
            </Typography>
        );
    }

    return (
        <Stack spacing={1.75}>
            {rows.map((row) => (
                <Box key={`${row.source}-${row.label}`}>
                    <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 0.5, gap: 1 }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "0.8125rem" }} noWrap title={row.label}>
                            {row.label || row.source}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
                            {row.sessions} sess · {row.views != null ? `${row.views} views` : "—"}
                        </Typography>
                    </Stack>
                    <Box
                        sx={{
                            height: 8,
                            borderRadius: 1,
                            bgcolor: "action.hover",
                            overflow: "hidden",
                        }}
                    >
                        <Box
                            sx={{
                                height: "100%",
                                width: `${row.pct}%`,
                                borderRadius: 1,
                                bgcolor: "primary.main",
                                opacity: 0.85,
                                minWidth: row.sessions > 0 ? 4 : 0,
                                transition: "width 0.35s ease",
                            }}
                        />
                    </Box>
                </Box>
            ))}
        </Stack>
    );
}
